export enum Direction {
    prev = 'prev',
    next = 'next',
}
